import { useId } from 'react';

import { checkoutStore } from '~/stores';

import { useDateItem } from './hooks';

interface DateItemProps {
  timeStamp: string;
  isDisabled: boolean;
  isChecked: boolean;
  onChange: (value: string) => void;
}

const DateItem = ({
  timeStamp,
  isDisabled,
  isChecked,
  onChange,
}: DateItemProps) => {
  const inputId = useId();
  const { day } = useDateItem({ timeStamp });

  const order = checkoutStore.slotSelectionModalStore.selectedOrder;

  if (!order) {
    throw new Error('Order not found');
  }

  return (
    <li className="list-item">
      <input
        data-radio="date"
        type="radio"
        value={timeStamp}
        id={inputId}
        name="date"
        checked={isChecked}
        onChange={({ target }) => {
          onChange(target.value);
        }}
        disabled={isDisabled}
      />
      <label htmlFor={inputId}>
        <span className="text-primary">{day}</span>
      </label>
    </li>
  );
};

export default DateItem;
